import React, { PureComponent } from 'react';
import WND from '../WND.js';
import MENUBAR from '../menus/MENUBAR';
import STATUSBAR from '../STATUSBAR';
import './EXPLORER.css';

let menu = [
    { text: "File", accel: "F" },
    { text: "Edit", accel: "E" },
    { text: "View", accel: "V" },
    { text: "Help", accel: "H" }
];

let paddingX = 3;
let paddingY = 4;

let strideY = 75;
let strideX = 75;

class EXPLORER_ICON extends PureComponent {
    constructor(props) {
        super(props);
        this.lastClickTime = 0;
    }

    onClick(e) {
        this.props.onSelect();

        let time = new Date().getTime();
        let dblClickTime = 1000;
        if ((time - this.lastClickTime) <= dblClickTime) {
            this.props.onOpen();
        } else {
            this.lastClickTime = time;
        }

        e.stopPropagation();
    }

    render() {
        let style = {
            left: this.props.position[0],
            top: this.props.position[1]
        };

        return <div className={"explorer-icon " + (this.props.selected ? "selected" : "") + " " + (this.props.isSoftLink ? "explorer-icon-link" : "")} style={style}>
            <div className="icon" onClick={this.onClick.bind(this)}><img src={this.props.icon} /></div>
            <div className="name" onClick={this.onClick.bind(this)}>{this.props.name}</div>
        </div>;
    }
}

export default class EXPLCTRL extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
        this.state.selectedIndex = -1;
        this.state.currentPositions = null;
    }
    
    calculatePositions(frameElm) {
        if (this.state.currentPositions == null) {
            // Recalculate positions
            let width = frameElm.offsetWidth;
            let height = frameElm.offsetHeight;
            let positions = [];

            var x = 0;
            var y = 0;
            for (var i = 0; i < this.props.directory.length; i++) {
                var position = [paddingX + x * strideX, paddingY + y * strideY];

                if (this.props.stackVertically) {
                    if ((y + 2) * strideY >= height) {
                        y = 0;
                        x += 1;
                    } else {
                        y += 1;
                    }
                } else {
                    if ((x + 2) * strideX >= width) {
                        x = 0;
                        y += 1;
                    } else {
                        x += 1;
                    }
                }

                positions.push(position);
            }

            this.setState({ currentPositions: positions });
        }
    }

    render() {
        let items = this.props.directory;

        let explorerFrame = <div className={"explorer-frame" + (this.props.showChrome ? " with-chrome" : "")}
            onClick={() => {
                this.setState({ selectedIndex: -1 });
            }}
            ref={this.calculatePositions.bind(this)}>
            <div className="explorer-frame-area">
            {this.state.currentPositions ?  items.map((item, i) => {
                let position = this.state.currentPositions[i];

                if (position) {
                    return <EXPLORER_ICON
                        key={i}
                        selected={this.state.selectedIndex == i}
                        position={this.state.currentPositions[i]}
                        icon={item.icon32}
                        name={item.displayName || item.name}
                        isSoftLink={item.type == "link" && item.isSoft}
                        onSelect={() => {
                            this.setState({ selectedIndex: i });
                        }}
                        onOpen={() => {
                            var path;
                            if (item.type == "link") {
                                path = item.destination;
                            } else {
                                let pathStart = this.props.path ?
                                    (this.props.path + "\\") : "";
                                path = pathStart + item.name;
                            }

                            window.WINAPI.ShellExecute(path);
                            this.setState({ selectedIndex: -1 });
                        }} />;
                } else {
                    return null;
                }
            }) : null}
            </div>
        </div>;

        if (this.props.showChrome) {
            let statusBarParts = [ items.length + " object(s)", "" ];

            return <STATUSBAR className="explorer" parts={statusBarParts}>
                <MENUBAR menu={menu} />
                {explorerFrame}
            </STATUSBAR>;
        } else {
            return explorerFrame;
        }
    }

    onFocusLost() {
        if (this.state.selectedIndex != -1) {
            this.setState({ selectedIndex: -1 });
        }
    }
}


// WEBPACK FOOTER //
// ./src/walleris/EXPLORE/EXPLCTRL.js